import { SidebarBoxKey } from 'AdmissionsGuidance';
import { useCurrentUser, useTargetBrandConfig } from 'FrontRoyalAngular';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';
import { BasicDesktopBox } from '../../BasicDesktopBox';

function WelcomeBoxComponent() {
    const currentUser = useCurrentUser();
    const brandConfig = useTargetBrandConfig();

    if (!currentUser) return null;

    return (
        <WelcomeBoxPresentation
            name={currentUser.nickname || currentUser.name}
            brandNameShort={brandConfig.brandNameShort}
        />
    );
}

function WelcomeBoxPresentation({ name, brandNameShort }: { name: string; brandNameShort: string }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'welcomeBox' });
    return (
        <div className="mb-7.5">
            <BasicDesktopBox boxKey={SidebarBoxKey.welcome} headerText={t('header', { brandNameShort, name })}>
                <Text as="p" className="mb-3.5">
                    {t('contentEnjoyYourTime')}
                </Text>
                <Text as="p">{t('contentHappyLearning')}</Text>
            </BasicDesktopBox>
        </div>
    );
}

export const WelcomeBox = memo(WelcomeBoxComponent) as unknown as typeof WelcomeBoxComponent;
